const ExcelImportRowState = {
  Success: 1,
  Warning: 2,
  Failure: 3
}

export { ExcelImportRowState }